import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faArrowsRotate } from '@fortawesome/pro-regular-svg-icons';
import { AppSettings } from 'pac-api';

import { AppComponent } from '../app.component';
import { serializeQueryParam } from '../helpers';
import { WizardService } from '../wizard/wizard.service';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.css']
})
export class RedirectComponent implements OnInit {

  public faArrowsRotate = faArrowsRotate;

  constructor(
    app: AppComponent,
    route: ActivatedRoute,
    router: Router,
    wizard: WizardService,
    settings: AppSettings,
    @Inject(DOCUMENT) doc: Document
  ) {
    app.wait();

    route.data.subscribe(data => {
      if ('ewebRedirect' in data && data.ewebRedirect) {
        const absolute = doc.location.origin + router.url;
        const query = { 'Site': settings.pac_base_asn_code, 'URL_Success': absolute };
        const search = serializeQueryParam(query);
        let url = settings.pac_base_nf_url;
        url += 'Login';
        url += search;
        wizard.wait().subscribe(_ => {
          doc.location.replace(url);
        });
      } else {
        wizard.wait().subscribe(_ => {
          doc.location.href = router.url;
        });
      }
    });

  }

  ngOnInit() {
  }

}
